import React from 'react'

import { I18n } from '@front/volcanion'
import { OptionSelectorField, TextField } from '@front/squirtle'

import { Typography, Grid, Box } from '@mui/material'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('staff.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size={4}>
      <TextField name={'username'} label={I18n.t('user.login_fleetizen')} />
    </Grid>
    <Grid size="grow">
      <OptionSelectorField
        name={'status'}
        label={I18n.t('status.label', { count: 1 })}
        valueType={'checkbox'}
        multiple
        options={[
          { label: I18n.t('status.active'), color: 'green', value: 'active' },
          { label: I18n.t('status.suspended'), color: 'orange', value: 'suspended' },
          { label: I18n.t('status.deleted'), color: 'red', value: 'deleted' },
        ]}
        getOptionLabelProps={({ color }) => ({ slotProps: { typography: { color } } })}
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
    </Grid>
  </Box>

export default React.memo(SearchForm)
